import React, { useEffect, useState } from 'react'
import { DatePicker } from '@ublique/components/DatePicker'
import NumberInput from 'components/NumberInput'

import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { first, isUndefined } from 'lodash'

const DATE_FORMAT = 'DD/MM/YYYY'
export const DEFAULT_LOCALE = 'en-GB'

function DateNumber({ onChange, className, disabled }) {
  const { i18n } = useTranslation()
  const lang = i18n.language ?? DEFAULT_LOCALE
  const locale = first(lang?.split('-'))

  const [days, setDays] = useState(0)
  const [date, setDate] = useState()

  const onDateChange = (e) => {
    setDate(moment(first(e)).format(DATE_FORMAT))
  }

  const onNumberChange = (e) => {
    setDays(e)
  }

  useEffect(() => {
    if (!isUndefined(date) && !isUndefined(days)) {
      const sign = days >= 0 ? '+' : ''

      const resultDate = moment(date, DATE_FORMAT)
        .add(days ?? 0, 'days')
        .format(DATE_FORMAT)

      const label = `${resultDate} (${date} ${sign}${days ?? 0})`
      onChange({
        params: { label, value: `'${resultDate}'` },
        isTriggered: true
      })
    }
  }, [date, days])

  return (
    <div className='date-number-custom'>
      <DatePicker
        className='date'
        dateFormat='d/m/Y'
        onChange={onDateChange}
        datePickerType='single'
        value={date}
        locale={locale}
      >
        <DatePicker.Input
          disabled={disabled}
          labelText='Date'
          placeholder='dd/mm/yyyy'
        />
      </DatePicker>
      <NumberInput
        className={`${className}-number`}
        label='Number'
        onChange={onNumberChange}
        value={days}
      />
    </div>
  )
}

export default DateNumber
